import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../../lib/amplify-client';

export interface TopUpPointsInput {
  bundle_id: string;
  idempotency_key: string;
}

export interface TopUpPointsResult {
  points_added: number;
  new_balance: number;
}

export async function topUpPoints(input: TopUpPointsInput): Promise<TopUpPointsResult> {
  /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
  const result: { data?: TopUpPointsResult; errors?: { message: string }[] } =
    await (client.mutations as any).topUpPoints(
      { bundle_id: input.bundle_id, idempotency_key: input.idempotency_key },
      { authMode: 'userPool' },
    );
  /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
  const errors = result.errors ?? [];
  if (errors.length > 0) {
    throw new Error(`topUpPoints failed: ${errors.map((e) => e.message).join('; ')}`);
  }
  const data = result.data;
  if (!data) throw new Error('topUpPoints returned an empty response.');
  return data;
}

export function useTopUpPointsMutation() {
  const queryClient = useQueryClient();
  return useMutation<TopUpPointsResult, Error, TopUpPointsInput>({
    mutationFn: topUpPoints,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['vouchers', 'balance'] });
    },
  });
}
